export default __webpack_public_path__ + "static/media/jit-leasex-logo-by.fffa9471.png";